var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isCheckoutPage || _vm.isPaymentConfirmPage || _vm.totalInfo
      ? _c("div", { class: _vm.$style.checkoutTotalMain }, [
          !_vm.isKioskPlatform
            ? _c("div", { class: _vm.$style.checkoutTotalInfo }, [
                _c("div", { class: _vm.$style.checkoutInfo }, [
                  _c("span", [_vm._v("Subtotal")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("toPrice")(_vm.subTotalCheckout)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { class: _vm.$style.checkoutInfo }, [
                  _c("span", [_vm._v("Discount")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm._f("toPrice")(_vm.discount)))])
                ]),
                _vm._v(" "),
                _c("div", { class: _vm.$style.checkoutInfo }, [
                  _c("span", [_vm._v("Tax")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("toPrice")(_vm.taxCheckout)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { class: _vm.$style.checkoutTotalOrder }, [
                  _c("span", [_vm._v("Total Order")]),
                  _vm._v(" "),
                  _c("span", { class: _vm.$style.checkoutTotalPrice }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("toPrice")(_vm.totalPriceCheckout)) +
                        "\n        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { class: _vm.$style.discountInfo }, [
                  _c(
                    "form",
                    {
                      class: _vm.$style.discountForm,
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.onDiscountSubmit($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { class: _vm.$style.discountFieldWrap },
                        [
                          _c("InputField", {
                            class: [
                              _vm.$style.discountField,
                              ((_obj = {}),
                              (_obj[_vm.$style.errorField] =
                                _vm.$v.discountField.$error),
                              _obj)
                            ],
                            attrs: {
                              disabled: _vm.disableDiscountField,
                              maxlength:
                                _vm.$v.discountField.$params.maxLength.max,
                              label: "Discount Code*"
                            },
                            model: {
                              value: _vm.$v.discountField.$model,
                              callback: function($$v) {
                                _vm.$set(_vm.$v.discountField, "$model", $$v)
                              },
                              expression: "$v.discountField.$model"
                            }
                          }),
                          _vm._v(" "),
                          [
                            _vm.hasAppliedDiscount
                              ? _c(
                                  "button",
                                  {
                                    class: [
                                      _vm.$style.discountSubmit,
                                      _vm.$style.discountReset
                                    ],
                                    attrs: {
                                      disabled: _vm.discountCodeIsUpdating,
                                      type: "button"
                                    },
                                    on: { click: _vm.resetDiscount }
                                  },
                                  [
                                    _vm._v(
                                      "\n                X\n              "
                                    )
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    class: _vm.$style.discountSubmit,
                                    attrs: {
                                      disabled: _vm.disableDiscountField,
                                      type: "button"
                                    },
                                    on: { click: _vm.onDiscountSubmit }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Submit\n              "
                                    )
                                  ]
                                )
                          ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.$v.discountField.maxLength
                        ? _c("p", { class: _vm.$style.errorMessage }, [
                            _vm._v(
                              "\n            Maximum length " +
                                _vm._s(
                                  _vm.$v.discountField.$params.maxLength.max
                                ) +
                                "\n            characters.\n          "
                            )
                          ])
                        : _vm.discountErrors.length
                        ? _c(
                            "div",
                            _vm._l(_vm.discountErrors, function(error, index) {
                              return _c(
                                "p",
                                { key: index, class: _vm.$style.errorMessage },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(error) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : !_vm.$v.discountField.$error && _vm.hasAppliedDiscount
                        ? _c("p", { class: _vm.$style.discountApplied }, [
                            _vm._v(
                              "\n            Discount code applied!\n          "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              ])
            : _c("div", { class: _vm.$style.checkoutTotalKiosk }, [
                _c(
                  "button",
                  {
                    class: _vm.$style.addBtn,
                    on: { click: _vm.handleAddItem }
                  },
                  [
                    _c("span", [
                      _c("svg", {
                        directives: [{ name: "svg", rawName: "v-svg" }],
                        class: _vm.$style.plusIcon,
                        attrs: { symbol: "plus-sign" }
                      })
                    ]),
                    _vm._v("\n        Add Item\n      ")
                  ]
                ),
                _vm._v(" "),
                _c("div", { class: _vm.$style.checkoutInfo }, [
                  _c("span", [_vm._v("Subtotal: $ " + _vm._s(19.31))]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Tax: $ " + _vm._s(3.29))])
                ]),
                _vm._v(" "),
                _c("div", { class: _vm.$style.checkoutTotal }, [
                  _c("button", { class: _vm.$style.discountBtn }, [
                    _vm._v("Have a Discount Code?")
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Total: $ " + _vm._s(40.33))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.$style.checkoutButtonsKiosk },
                  [
                    _c(
                      "BaseButton",
                      {
                        class: _vm.$style.startBtn,
                        attrs: { "button-style": "Back" },
                        on: { click: _vm.handleStartOver }
                      },
                      [_vm._v("\n          Start Over\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "BaseButton",
                      {
                        class: _vm.$style.checkoutBtn,
                        attrs: {
                          disabled: !_vm.cartCompleted,
                          "button-style": "Main"
                        },
                        on: { click: _vm.handleCheckout }
                      },
                      [_vm._v("\n          Checkout\n        ")]
                    )
                  ],
                  1
                )
              ])
        ])
      : _c("div", { class: _vm.$style.totalOrderButtons }, [
          _c(
            "button",
            { class: _vm.$style.addBtn, on: { click: _vm.handleAddItem } },
            [
              _c("span", [
                _c("svg", {
                  directives: [{ name: "svg", rawName: "v-svg" }],
                  class: _vm.$style.plusIcon,
                  attrs: { symbol: "plus-sign" }
                })
              ]),
              _vm._v("\n      Add Item\n    ")
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                _vm.$style.subtotal,
                ((_obj$1 = {}),
                (_obj$1[_vm.$style.isLoading] = _vm.cartOrderIsUpdated),
                _obj$1)
              ]
            },
            [
              _vm.cartOrderIsUpdated ? _c("LoadingSpinner") : _vm._e(),
              _vm._v(" "),
              _vm.calculatedOrder
                ? [
                    _c("div", { class: _vm.$style.subtotalItem }, [
                      _c("h6", [_vm._v("Subtotal")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("toPrice")(_vm.subTotalCalc)))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { class: _vm.$style.subtotalItem }, [
                      _c("h6", [_vm._v("Tax")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("toPrice")(_vm.taxCalc)))
                      ])
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isKioskPlatform && _vm.discount > 0
                ? _c("div", { class: _vm.$style.subtotalItem }, [
                    _c("h6", [_vm._v("Discount")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("toPrice")(_vm.discountCalc)))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [_vm.$style.subtotalItem, _vm.$style.subtotalItemBold]
                },
                [
                  _c("h6", [_vm._v("Total")]),
                  _vm._v(" "),
                  _vm.isKioskPlatform &&
                  _vm.order &&
                  _vm.order.discountPrice > 0
                    ? _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("toPrice")(_vm.totalPriceCalc)) +
                            "\n        "
                        )
                      ])
                    : _c("span", [
                        _vm._v(_vm._s(_vm._f("toPrice")(_vm.totalPriceCalc)))
                      ])
                ]
              ),
              _vm._v(" "),
              !_vm.isKioskPlatform
                ? _c("div", [
                    _c("p", { class: _vm.$style.discountMessage }, [
                      _vm._v(
                        "\n          Discounts will be reflected at checkout.\n        "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isKioskPlatform && _vm.discount === 0
                ? _c("div", [
                    _c(
                      "button",
                      {
                        class: _vm.$style.kioskDiscountBtn,
                        on: { click: _vm.enterDiscountCode }
                      },
                      [_vm._v("Have a Discount Code?")]
                    )
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          !_vm.isKioskPlatform
            ? _c(
                "div",
                { class: _vm.$style.checkoutButtons },
                [
                  _c(
                    "BaseButton",
                    {
                      class: _vm.$style.squareButton,
                      attrs: {
                        disabled: _vm.cartLength === 0,
                        "button-style": "Main"
                      },
                      on: { click: _vm.handleStartOver }
                    },
                    [_vm._v("\n        Start Over\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "BaseButton",
                    {
                      class: _vm.$style.squareButton,
                      attrs: {
                        disabled: !_vm.cartCompleted,
                        "button-style": "Main"
                      },
                      on: { click: _vm.handleCheckout }
                    },
                    [_vm._v("\n        Checkout\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isKioskPlatform
            ? _c(
                "div",
                { class: _vm.$style.checkoutButtonsKiosk },
                [
                  _c(
                    "BaseButton",
                    {
                      class: _vm.$style.startBtn,
                      attrs: {
                        disabled: _vm.cartLength === 0,
                        "button-style": "Main"
                      },
                      on: { click: _vm.handleStartOver }
                    },
                    [_vm._v("\n        Start Over\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "BaseButton",
                    {
                      class: _vm.$style.checkoutBtn,
                      attrs: {
                        disabled: !_vm.cartCompleted,
                        "button-style": "Main"
                      },
                      on: { click: _vm.handleCheckout }
                    },
                    [_vm._v("\n        Checkout\n      ")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/cart/components/CartTotal.vue?vue&type=template&id=1bb9e1f6&
// module id = null
// module chunks = 